// src/components/Skeleton.jsx — lightweight shimmer placeholders so pages
// show their shape while loading instead of a bare centered spinner.
import { useEffect } from 'react';

let injected = false;
function useShimmerStyle() {
  useEffect(() => {
    if (injected || typeof document === 'undefined') return;
    injected = true;
    const el = document.createElement('style');
    el.textContent = `@keyframes tt-shimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}
.tt-skel{background:linear-gradient(90deg,var(--nat-s) 25%,var(--nat-d) 37%,var(--nat-s) 63%);background-size:800px 100%;animation:tt-shimmer 1.4s ease infinite;border-radius:8px}`;
    document.head.appendChild(el);
  }, []);
}

export function Skeleton({ width = '100%', height = 14, radius = 8, style }) {
  useShimmerStyle();
  return <div className="tt-skel" style={{ width, height, borderRadius: radius, ...style }} />;
}

// A card-shaped placeholder for grid layouts.
export function SkeletonCard({ lines = 3, height }) {
  useShimmerStyle();
  return (
    <div style={{ background: 'var(--white)', border: '1px solid var(--nat-d)', borderRadius: 14, padding: 18, display: 'flex', flexDirection: 'column', gap: 12, minHeight: height }}>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <Skeleton width={44} height={44} radius={10} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 7 }}>
          <Skeleton width="60%" height={13} />
          <Skeleton width="40%" height={11} />
        </div>
      </div>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} width={`${90 - i * 12}%`} height={11} />
      ))}
    </div>
  );
}

// A responsive grid of skeleton cards.
export function SkeletonGrid({ count = 6, minWidth = 280, lines = 3 }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))`, gap: 16 }}>
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} lines={lines} />)}
    </div>
  );
}
